import { render } from "./main.vue?vue&type=template&id=06ac7e36&scoped=true&ts=true"
import script from "./main.vue?vue&type=script&lang=ts"
export * from "./main.vue?vue&type=script&lang=ts"

import "./main.vue?vue&type=style&index=0&id=06ac7e36&scoped=true&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ac7e36"]])

export default __exports__